import "core-js/modules/es.array.push.js";
import api from "./../../../../common/api";
import common from "./../../../../common/common.js";
import { ElMessage } from 'element-plus';
import Upload from '../../../components/upload';
import qs from 'qs';
export default {
  name: 'user_edit',
  components: {
    Upload
  },
  props: {
    action: {
      type: String,
      value: 'add'
    },
    actionUrl: {
      type: String,
      value: '/admins/add'
    },
    departmentData: {
      type: Array,
      value: []
    },
    userDataOne: {
      type: Object,
      value: {}
    }
  },
  data: function () {
    return {
      loading: false,
      loading_text: '加载中..',
      headers: {
        'Content-Type': 'multipart/form-data;'
      },
      uploading_loading: false,
      uploading_loading_text: '正在上传...',
      upload_url: api.upload(),
      sizeMax: 200 * 1024 * 1024,
      //头像图片质量大小
      config: {
        headers: {
          'Content-Type': 'multipart/form-data;'
        },
        timeout: 50000
      },
      // 添加请求头
      storeData: [{
        store_name: '请选择',
        store_id: 0
      }],
      //门店列表
      orgData: [{
        org_name: '请选择',
        org_id: ''
      }],
      //机构列表
      admins: this.userInit(),
      roleData: [{
        role_name: '请选择角色',
        id: ''
      }],
      //角色列表
      appointmentNumberMsg: '',
      userInfo: {} //当前用户信息
    };
  },

  created: function () {
    if (localStorage.getItem('isLogin')) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        this.userInfo = userInfo;
        this.roles();
        this.orgList();
        this.storeList();
        if (this.action != 'add') {
          this.admins = this.userDataOne;
        }
      }
    }
  },
  methods: {
    orgChange: function (e) {
      console.log('e', e);
    },
    getUploadFile: function (e) {
      this.admins.avatar = e[0] && e[0].url ? e[0].url : '';
    },
    submit: common.throttle(function () {
      //return false;
      var that = this;
      // var checkData = this.checkData();
      // if(!checkData){
      // 	return false;
      // }
      this.loading = true;
      var data = this.admins;
      // 异步更新数据
      this.$post(api.doMain() + that.actionUrl, qs.stringify(qs.parse(data))).then(async function (res) {
        that.loading = false;
        if (res.rt == 1) {
          //var id = res.id?res.id:data.id;
          //await that.AddAppointmentNumber({id:id,appointment_number:data.appointment_number,wechat_number:data.wechat_number});
          setTimeout(await function () {
            // if(that.appointmentNumberMsg){
            // 	return false
            // }
            ElMessage({
              type: 'success',
              message: res.msg,
              showClose: true,
              duration: 1500
            });
            that.userInit(); //初始化
            that.$emit('userEdit_close', {});
            if (that.action == 'edit_oneself') {
              data.routes = that.userInfo.routes;
              localStorage.setItem('userInfo', JSON.stringify(data));
              console.log(JSON.parse(localStorage.getItem('userInfo')));
            } else {
              that.$emit('submit', {});
            }
          }, 200);
        } else {
          //that.err[`${res.id}`] = res.msg;//动态变量赋值
          ElMessage({
            type: 'warning',
            message: res.msg,
            showClose: true,
            duration: 2000
          });
          if (res.page) {
            setTimeout(function () {
              common.clearLogin();
              that.$router.push(res.page);
            }, 300);
          }
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
      });
    }),
    uploadError: function (res) {
      console.log('error-res', res);
    },
    uploadSuccess: function () {
      //this.uploading_loading = false;
      //console.log('success');
    },
    upload_avatar: function (uploadfile) {
      var that = this;
      var data = new FormData();
      that.uploading_loading = true;
      data.append('file', uploadfile.file);
      data.append('file_type', 'images');
      //data.append('file_type','file');
      data.append('file_flag', 'userAvatar');
      this.$post(api.upload(), data, that.config).then(function (res) {
        console.log('res', res);
        setTimeout(function () {
          that.uploading_loading = false;
        }, 300);
        if (res.rt == 1) {
          var admins = that.admins;
          admins.avatar = res.url;
          that.admins = admins;
          console.log('admins', that.admins);
        } else {
          var msg = res.msg;
          if (msg) {
            ElMessage.error(msg);
          }
          if (res.page) {
            setTimeout(function () {
              common.clearLogin();
              that.$router.push(res.page);
            }, 300);
          }
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
      });
    },
    beforeAvatarUpload: function (rawFile) {
      console.log('rawFile.type', rawFile.type);
      var reg_img = /^image\/[jpeg|jpg|png|gif]+$/;
      if (!reg_img.test(rawFile.type)) {
        ElMessage.error('图片格式须为jpeg|jpg|png!');
        return false;
      } else if (rawFile.size > this.sizeMax) {
        ElMessage.error('图片质量须小于' + parseInt(this.sizeMax / 1024 / 1024) + 'M');
        return false;
      }
      return true;
    },
    roles: function () {
      var that = this;
      var data = {};
      // 异步更新数据
      this.$post(api.doMain() + '/role/getTree', qs.stringify(qs.parse(data))).then(function (res) {
        if (res.rt == 1) {
          var roleData = that.roleData;
          roleData = roleData.concat(res.roleTreeSelect);
          that.roleData = roleData;
        } else {
          //that.err[`${res.id}`] = res.msg;//动态变量赋值
          ElMessage({
            type: 'warning',
            message: res.msg,
            showClose: true,
            duration: 2000
          });
          if (res.page) {
            setTimeout(function () {
              common.clearLogin();
              that.$router.push(res.page);
            }, 300);
          }
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
      });
    },
    storeList: function () {
      var that = this;
      this.loading = true;
      var data = {};
      // 异步更新数据
      this.$post(api.doMain() + '/shop/stores/myStoreAll', qs.stringify(qs.parse(data))).then(function (res) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        if (res.rt == 1) {
          var storeData = that.storeData;
          storeData = storeData.concat(res.storeData);
          that.storeData = storeData;
        } else {
          that.isLogout = true;
          //that.err[`${res.id}`] = res.msg;//动态变量赋值
          ElMessage({
            type: 'warning',
            message: res.msg,
            showClose: true,
            duration: 2000
          });
          if (res.page) {
            setTimeout(function () {
              common.clearLogin();
              that.$router.push(res.page);
            }, 300);
          }
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
        //vant.Toast.loading({message:'网络不稳，重新加载'});
      });
    },

    orgList: function () {
      var that = this;
      this.loading = true;
      var data = {};
      // 异步更新数据
      this.$post(api.doMain() + '/org/getAll', qs.stringify(qs.parse(data))).then(function (res) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        if (res.rt == 1) {
          var orgList = that.orgData;
          orgList = orgList.concat(res.orgData);
          var len = orgList.length;
          var orgData = [];
          if (len > 0) {
            for (var i = 0; i < len; i++) {
              orgData.push({
                org_id: Number(orgList[i].org_id),
                org_name: orgList[i].org_name
              });
            }
          }
          that.orgData = orgData;
          // console.log('that.orgData',that.orgData)
        } else {
          that.isLogout = true;
          //that.err[`${res.id}`] = res.msg;//动态变量赋值
          ElMessage({
            type: 'warning',
            message: res.msg,
            showClose: true,
            duration: 2000
          });
          if (res.page) {
            setTimeout(function () {
              common.clearLogin();
              that.$router.push(res.page);
            }, 300);
          }
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
        //vant.Toast.loading({message:'网络不稳，重新加载'});
      });
    },

    cancel: function () {
      this.admins = this.userInit();
    },
    userInit() {
      var admins = {
        id: '',
        org_id: [],
        store_id: [],
        username: '',
        mobile: '',
        password_old: '',
        password: '',
        password_confirm: '',
        email: '',
        avatar: '',
        role: [],
        role_name: '',
        avatarFileList: []
      };
      return admins;
    },
    close: function () {
      this.$emit('userEdit_close', {});
    }
  }
};